<router-outlet name="lightbox"></router-outlet>
<mb-article
  [article]="article"
  [defaultActions]="defaultActions"
  [articleActions]="articleActions"
  [sectionActions]="sectionActions"
></mb-article>
